<div class="login-assistant-page-container">
  <div class="header-red">
    <span class="d-inline-block text-truncate header-text" id="organisation-selector-title">{{ 'login-assistant.organisation-list.schools' | translate }}</span>
  </div>

  <div class="group-tile-container">
    <au-notification-bar #notificationBar id="organisation-token-error-notification"></au-notification-bar>
    <div id="organisation-list-container" class="tiles-wrapper">
      <au-tile [tile]="personnelTile" (onClick)="selectPersonnel()"></au-tile>
      <au-tile *ngFor="let organisation of organisationTiles" [tile]="organisation" (onClick)="selectOrganisation(organisation)"></au-tile>
    </div>
  </div>
</div>
